import React from 'react'

import logo from '../component/media/questa logo.png'
import d17 from './AboutUs.module.css'
function AboutUs() {
    return (
        <div className={d17.AboutUs}>
        <p>About Us:</p>    
<div className={d17.logo}><img alt='tan-q' src={logo}/></div>
        <p>   We are a group of freshly graduated and motivated people, consisted of teachers who gave private sessions for students for years, and programmers who worked on a high level and participated in many workshops.</p>
 <p>       
After noticing the issues and problems the students face when studying alone at home, we decided to create an easy to use platform for any student to ask any question about any school subject.</p>
<p>
Our mission is to ensure the support when studying for anyone, at anytime and anywhere. We want to motivate the students to ask more and therefore, study more and understanding better.
Questa <b>is the student's best friend</b>.</p>

        </div>
    )
}

export default AboutUs
